import dayjs from 'dayjs'
import jwtDecode from 'jwt-decode'
import React from 'react'

/**
 * * Handle tokens
 */
export const isUserTokenExpired = (token) => {
  if (token) {
    const { exp } = jwtDecode(token)
    return !exp || dayjs().isAfter(dayjs(exp * 1000))
  }
  return true
}

export const getUserId = (token) => {
  if (token) {
    const { sub } = jwtDecode(token)
    return sub
  } else {
    return false
  }
}

/**
 * * Handle children
 */

const addPropsToReactElement = (element, props, key) => {
  if (React.isValidElement(element)) {
    return (
      <React.Fragment key={key}>
        {React.cloneElement(element, props)}
      </React.Fragment>
    )
  }
  return element
}

export const addPropsToChildren = (children, props) => {
  if (!Array.isArray(children)) {
    return addPropsToReactElement(children, props)
  }
  return children.map((childElement, key) =>
    addPropsToReactElement(childElement, props, key)
  )
}

export const emailRegExp = new RegExp(
  '^([a-zA-Z0-9_\\-\\.+]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]+)$'
)

// eslint-disable-next-line prettier/prettier
export const phoneRegExp = new RegExp(
  '^(?:[+]|00|0)?(?:(?:33|262|376|590|594|596)[0-9]{9}|(?:6|7|689)[0-9]{8}|(?:508|687|681)[0-9]{6})$'
)

export const passwordRegExp = new RegExp(
  '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z\\d]+).{8,}$'
)

export const siretRegExp = new RegExp('^\\d{14}$')

export const WIDTH = window.innerWidth
